import {connectedAtom} from "../js/ConnectedStore";
import {RadioBtnChoice} from "../js-app/elements/FormElements";

declare var NeoData: any;

export type WP_Img = {
	thumbnail?:[url:string,w:number,h:number],
	large?:[url:string,w:number,h:number],
	medium?:[url:string,w:number,h:number],
	medium_large?:[url:string,w:number,h:number],
}
export type WP_Occasion = {
	id:number,
	link:string,
	name:string,
	included:boolean,
	inactive:boolean, //for now this is used for compatibility of UI, but the ACF option is not implemented in WP
	thumb?:WP_Img,
	parent:number
}
export type WP_Activity = {
	id:number,
	link:string,
	name:string,
	included:boolean,
	inactive:boolean,
	thumb?:WP_Img,
	variants?:{
		booking_id:string,
		name:string,
		img:WP_Img
	}[]
};

var initData = [];
var initOcc = [];
try{
	initData = NeoData.data.activities ?NeoData.data.activities : [];
	initData = initData.map((a)=>{
		return {...a,included:a.included == 'true', inactive:a.inactive == 'true'}
	});
}catch (e){}
try{
	initOcc = NeoData.data.occasions ? NeoData.data.occasions : [];
	initOcc = initOcc.map((a)=>{
		return {...a,included:a.included == 'true',inactive:a.inactive == 'true'}; //inactive will always be false, since data doesn't come from WP.
	});
}catch (e){}

// @ts-ignore
export const as_activities = connectedAtom<WP_Activity[]>({key:'acts',default:initData});
export const as_occasions = connectedAtom<WP_Occasion[]>({key:'occs',default:initOcc});
export const as_syncing = connectedAtom<boolean>({key:'syncs',default:false});
export const as_lastSync = connectedAtom<number>({key:'lastsync',default:NeoData?.data?.lastsync ? parseInt(NeoData.data.lastsync) : -1});
export const as_lastSyncOcc = connectedAtom<number>({key:'lastsync_occ',default:NeoData?.data?.lastsync_occasions ? parseInt(NeoData.data.lastsync_occasions) : -1});

export type WP_InputDef = {
	key:string,
	lbl:string,
    min?:number,
    max?:number,
	req?:boolean, //defaults to false
	type?:string //defaults to "text"
    options?:RadioBtnChoice[] //for select
}
export type WP_FormDef = {
	rows:WP_InputDef[][]
}
export type WP_FormSettings = {
	title0:string,title1:string,title2:string,title3:string,title4:string,title5:string,
	text0:string,text1:string,text2:string,text3:string,text4:string,text5:string,
	datasafetylink:string,
	forwardlink:string,
	cities:string[],
	backend_subject?:string,
	backend_recepient?:string,
	backend_reply?:string,
	backend_email?:string,
	formdata:WP_FormDef
	generalCss?:string,
};
export const as_serverSettings = connectedAtom<WP_FormSettings|null>({key:'formsettings',default:NeoData.data.formData })

export type WP_EmailSettings = {
	backend_subject?:string,
	backend_recepient?:string,
	backend_reply?:string,
	backend_from?:string,
	backend_email?:string,
};
export const as_emailSettings = connectedAtom<WP_EmailSettings|null>({key:'emailsettings',default:NeoData.data.emailData })


export const WP_MenuButtonsVariables = [
]
export type WP_MemoSettings = {
	css:{[key:string]:string}
	anim:{[key:string]:string}
	
	//Values for menu button
	'mmb-highlight'?:string,
	'mmb-text-on-highlight-col'?:string,
	'mmb-popup-text-col'?:string,
	'mmb-popup-bg-col'?:string
	customMMBCss?:string
	mmbPopupTitle?:string
	mmbPopupText?:string
	
}
export const as_memoSettings = connectedAtom<WP_MemoSettings|null>({key:'memosettings',default:NeoData.data.memoData || {} })

	
